export enum ZoneTypeEnum {
    LOAD = 10,
    DUMP = 20
}